/* =====================================================================
   KERST SALE collectiepagina - gedrag (2026-09-09)
   1. Kerstballen schommelen wild bij hover/tik (klasse .is-wild, animatie
      in collection-kerst.css) en komen daarna weer tot rust.
   2. Lichte parallax van sneeuw, mist, maan en arreslee op muisbeweging
      (alleen bij een fijne aanwijzer en zonder prefers-reduced-motion).
   Filters, sorteren, voorraad-toggle en "Toon meer" komen uit de gedeelde
   coll-filters-v2.js en load-more-init; hier wordt daar niets van geraakt.
   Geen aftelklok op deze pagina.
   ===================================================================== */
(function () {
  'use strict';

  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ---------- 1. Kerstballen ---------- */
  function initBaubles() {
    var baubles = document.querySelectorAll('[data-ks-bauble]');
    if (!baubles.length || reduceMotion) return;
    Array.prototype.forEach.call(baubles, function (bb) {
      var ball = bb.querySelector('.ks-bauble__svg');
      if (!ball) return;
      var busy = false;
      function swing() {
        if (busy) return;
        busy = true;
        bb.classList.add('is-wild');
        setTimeout(function () {
          bb.classList.remove('is-wild');
          busy = false;
        }, 1800);
      }
      ball.addEventListener('pointerenter', swing);
      ball.addEventListener('touchstart', swing, { passive: true });
    });
  }

  /* ---------- 2. Parallax ---------- */
  function initParallax() {
    var banner = document.querySelector('[data-ks-banner]');
    if (!banner || reduceMotion) return;
    var fine = false;
    try { fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) {}
    if (!fine) return;
    var raf = null, px = 0, py = 0;

    function apply() {
      raf = null;
      banner.style.setProperty('--px', px.toFixed(3));
      banner.style.setProperty('--py', py.toFixed(3));
    }
    banner.addEventListener('pointermove', function (e) {
      var r = banner.getBoundingClientRect();
      if (!r.width || !r.height) return;
      px = ((e.clientX - r.left) / r.width - 0.5) * 2;
      py = ((e.clientY - r.top) / r.height - 0.5) * 2;
      if (!raf) raf = requestAnimationFrame(apply);
    });
    banner.addEventListener('pointerleave', function () {
      px = 0; py = 0;
      if (!raf) raf = requestAnimationFrame(apply);
    });
  }

  function init() {
    initBaubles();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
